export function pad(n) {
    return n<10?`0${n}`:`${n}`;
}

export function addDays(date, days) {
    let res = new Date(date);
    res.setDate(res.getDate() + days);
    return res;
}

export function datesEqual(d1, d2) {
    return d1.getTime() === d2.getTime();
}

export function resetHours(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
}

export function isValidDate(date) {
    return date instanceof Date && !isNaN(date);
}